import { render, staticRenderFns } from "./NextToPlay.vue?vue&type=template&id=cb1008e0"
import script from "./NextToPlay.vue?vue&type=script&lang=js"
export * from "./NextToPlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports